export const BaseUrl = process.env.REACT_APP_API_URL;
export const versionControl = "v1/";
export const BUCKET_URL = process.env.REACT_APP_BUCKET_URL;

export const api = {
    login: "admin/login",
    forgotPassword: "admin/forgotPassword",
    otpVerification: "admin/otpVerification",
    updatePassword: "admin/updatePassword",
    get_all_notifications: "admin/get_all_notifications",

    // File Upload API
    image: "upload/image",

    // Vendors API
    getVendors: "admin/getVendors",
    getVendorById: "admin/getVendorById",
    downloadVendor: "admin/downloadVendor",
    addVendor: "admin/addVendor",
    updateVendor: "admin/updateVendor",

    //  Inventory API
    getInventories: "admin/getInventories",
    addInventory: "admin/addInventory",
    updateInventory: "admin/updateInventory",
    getInventoryById: "admin/getInventoryById",
    deleteInventory: "admin/deleteInventory",
    getAllItemName: "admin/getAllItemName",
    getAllItemsByCategory: "admin/getAllItemsByCategory",
    createProduct: "admin/createProduct",
    getProductData: "admin/getProductData",
    deleteProduct: "admin/deleteProduct",
    getProductById:"admin/getProductById",

    // Master Inventory API
    getInventoryFields: "admin/getInventoryFields",
    addInventoryField: "admin/addInventoryField",
    updateInventoryField: "admin/updateInventoryField",
    getInventoryFieldById: "admin/getInventoryFieldById",
    deleteInventoryField: "admin/deleteInventoryField",
    // Purchase Order API
    downloadPO: "admin/downloadPO",
    addPurchaseOrder: "admin/addPurchaseOrder",
    getPurchaseOrders: "admin/getPurchaseOrders",
    getPODocumetsPoNumbers: "admin/getPODocumetsPoNumbers",
    getAdvanceLicensesForPODoc: "admin/getAdvanceLicensesForPODoc",
    getAdvancelicenseNumber:"admin/getAdvancelicenseNumber",
    getPurchaseOrderById: "admin/getPurchaseOrderById",
    deletePurchaseOrder: "admin/deletePurchaseOrder",
    updatePurchaseOrder: "admin/updatePurchaseOrder",
    downloadpurchaseOrderExcel: "admin/downloadpurchaseOrderExcel",




    //PO Documents
    addPODocument: "admin/addPODocument",
    updatePODocument: "admin/updatePODocument",
    getPODocuments: "admin/getPODocuments",
    deletePODocument: "admin/deletePODocument",
    getPODocumentById: "admin/getPODocumentById",
    changeStatusOfPurchaseOrder: "admin/changeStatusOfPurchaseOrder",
    getPoDcumentsByPoNumber: "admin/getPoDcumentsByPoNumber",
    getPoDocumentsByPoNumber: "admin/getPoDocumentsByPoNumber",

    //Purchase Entery APIs
    getAllPOList: "admin/getAllPOList",
    getPoNumbersByVendor: "admin/getPoNumbersByVendor",
    addPurchaseEntry: "admin/addPurchaseEntry",
    getPurchaseEntrys: "admin/getPurchaseEntrys",
    getPurchaseEntryById: "admin/getPurchaseEntryById",
    downloadGrn: "admin/downloadGrn",
    deletePurchaseEntry: "admin/deletePurchaseEntry",
    getRemainingQuantity: "admin/getRemainingQuantity",
    updateRemainingQuantityByPONumber: "admin/updateRemainingQuantityByPONumber",
    updatePurchaseEntry: "admin/updatePurchaseEntry",
    getPurchaseEntryItems:"admin/getPurchaseEntryItems",
    getPurchaseEntryNumber:"admin/getPurchaseEntryNumber",

    //Lot Number APIs
    addLotNumber: "admin/addLotNumber",
    getLotNumbers: "admin/getLotNumbers",
    getLotNumberById: "admin/getLotNumberById",
    deleteLotNumber: "admin/deleteLotNumber",
    updateLotNumber: "admin/updateLotNumber",
    getPerticularLotNumbers: "admin/getPerticularLotNumbers",
    getPOItem: "admin/getPOItem",
    getGrnAndLotNumberByPoNumber: "admin/getGrnAndLotNumberByPoNumber",

    //Production APIs
    getProductionLotNumber: "admin/getProductionLotNumber",
    getItemForUpdateProduction: "admin/getItemForUpdateProduction",
    getItemByLotNumber: "admin/getItemByLotNumber",
    getAllProductionList: "admin/getAllProductionList",
    getPerticularProductionAllItem: "admin/getPerticularProductionAllItem",
    moveItemToProduction: "admin/moveItemToProduction",
    deleteProduction: "admin/deleteProduction",
    updateProduction: "admin/updateProduction",

    //Processing APIs
    getProcessItems: "admin/getProcessItems",
    getLotNumbersByCategory: "admin/getLotNumbersByCategory",
    getItemsByCategory: "admin/getItemsByCategory",
    getProcessItemById: "admin/getProcessItemById",
    updateProcessItem: "admin/updateProcessItem",
    addProcessItem: "admin/addProcessItem",
    deleteProcessItem: "admin/deleteProcessItem",

    //Processing APIs
    addDocument: "admin/addDocument",
    updateDocument: "admin/updateDocument",
    getDocuments: "admin/getDocuments",
    getDocumentsByType: "admin/getDocumentsByType",
    getTotalProduction: "admin/getTotalProduction",
    getDocumentById: "admin/getDocumentById",
    getPoDocumentsByAdvanceLicense: "admin/getPoDocumentsByAdvanceLicense",
    deleteDocument: "admin/deleteDocument",
    downloadSheet: "admin/downloadSheet",
    getInvoiceItemById: "admin/getInvoiceItemById",

    // Role APIs
    getRoleManagement: "admin/getRoleManagement",
    addRoleManagement: "admin/addRoleManagement",
    updateRoleManagement: "admin/updateRoleManagement",
    getRoleManagementById: "admin/getRoleManagementById",
    deleteRoleManagement: "admin/deleteRoleManagement",

    getPermission: "admin/getPermissionByEmail",

    //dashboard
    VandorOverview: "admin/getVandorOverview",
    getVendorOverview: "admin/getVendorOverview",
    getPoStatus :'admin/getPoStatus',
    getPoTableStatus : 'admin/getPoList',

    getExpense : 'admin/getExpense',
    getSalesAndPurchase : 'admin/getPurchaseAndSales',
    getAllRevenue : 'admin/getAllRevenue',

    // Account (billing) APIs
    create_customer: "account/customer/create_customer",
    update_customer: "account/customer/update_customer",
    get_customers: "account/customer/get_customers",
    get_customer_by_id: "account/customer/get_customer_by_id",
    countries: "account/customer/countries",
    states: "account/customer/states",
    cities: "account/customer/cities",
    delete_customer: "account/customer/delete_customer/",
    get_items: "account/item/get_items",
    create_items: "account/item/create_item",
    get_item_by_id: "account/item/get_item_by_id",
    delete_item: "account/item/delete_item/",
    update_item: "account/item/update_item",
    get_gst_rates: "account/gst/get_gst_rates",
    create_gst_rate: "account/gst/create_gst_rate",
    update_gst_rate: "account/gst/update_gst_rate",
    delete_gst_rate: "account/gst/delete_gst_rate/",
    get_payment_terms: "account/payment_terms/get_payment_terms",
    create_payment_term: "account/payment_terms/create_payment_term",
    update_payment_term: "account/payment_terms/update_payment_term",
    delete_payment_term: "account/payment_terms/delete_payment_term/",
    get_invoices: "account/invoice/get_invoices",
    create_invoice: "account/invoice/create_invoice",
    update_invoice: "account/invoice/update_invoice",
    delete_invoice: "account/invoice/delete_invoice/",
    get_invoice_by_id: "account/invoice/get_invoice_by_id",
    download_invoice_pdf: "account/invoice/download_invoice_pdf",
    get_monthwise_item_summary: "account/dashboard/get_monthwise_item_summary",
    get_customer_invoice_summary: "account/dashboard/get_customer_invoice_summary",
    get_customers_by_year_country: "account/dashboard/get_customers_by_year_country",
    get_countryWise_summary: "account/dashboard/get_countryWise_summary",
    get_customer_summary: "account/dashboard/get_customer_summary",
    get_avg_item_summary: "account/dashboard/get_avg_item_summary",
    get_ai_insights: "account/dashboard/get_ai_insights",
    ai_chat: "account/dashboard/ai_chat",

};

export const LOGIN_TOKEN = "LOGIN_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";

export const fileKey = (path) => {
    if (!path) return "";
    if (typeof path === "object") {
        if (Array.isArray(path)) return fileKey(path[0]);
        return fileKey(path.image || path.document || "");
    }
    const s = String(path);
    if (/^https?:\/\//i.test(s)) {
        try { return decodeURIComponent(new URL(s).pathname.replace(/^\//, "")); }
        catch { return s; }
    }
    return s.replace(/^\//, "");
};

export const fileName = (path) => fileKey(path).split("/").pop() || "Document";

const FILE_TYPES = { pdf: "application/pdf", png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg", gif: "image/gif", webp: "image/webp", xls: "application/vnd.ms-excel", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" };

let showPreview;

export const bindFilePreview = (fn) => { showPreview = fn; };

export async function loadFile(path) {
    const key = fileKey(path);
    if (!key) return null;
    const token = sessionStorage.getItem(LOGIN_TOKEN);
    const res = await fetch(`${BaseUrl}upload/file?key=${encodeURIComponent(key)}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) return null;
    const raw = await res.blob();
    const ext = key.split(".").pop().toLowerCase();
    const type = FILE_TYPES[ext] || raw.type || "application/octet-stream";
    const blob = raw.type === type ? raw : new Blob([raw], { type });
    return { url: URL.createObjectURL(blob), name: fileName(key), type, blob };
}

export async function openFile(path) {
    if (showPreview) {
        showPreview(path);
        return true;
    }
    const file = await loadFile(path);
    if (!file) return false;
    const w = window.open(file.url, "_blank");
    if (!w) URL.revokeObjectURL(file.url);
    return !!w;
}